import BaseController from 'app/src/controllers/base/BaseController';
import GatewayLSPaymentsView from 'app/src/views/settings/paymentProcessing/GatewayLSPaymentsView';

export default class LSBannerViewController extends BaseController {
  constructor() {
    super();

    this.view = new GatewayLSPaymentsView();
  }

  /**
   * Provisioning for abstraction
   */
}
